import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c(VMain,[_c('error-general',{attrs:{"title":_vm.title,"description":_vm.description,"back-to-home":_vm.backToHome}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }